export const FACTURA_ID_TO_CBTE = {
    1: 1,
    2: 6,
    3: 11,
    7: 51,
  }
  
  export const normalizarDocumentoFiscal = (value) => String(value || "").replace(/\D/g, "")
  
  export const calcularIvaDetalladoPorAlicuotas = (items, ivaAFIP = []) => {
    const gruposIva = {}
  
    ;(items || []).forEach((item) => {
      let porcentajeIva = 21
  
      if (item?.impuestoData && item.impuestoData.porcentaje !== undefined) {
        porcentajeIva = Number(item.impuestoData.porcentaje)
      } else if (item?.ivaPercentage !== undefined) {
        porcentajeIva = Number(item.ivaPercentage)
      }
  
      const ivaAFIPEncontrado = ivaAFIP.find((iva) => Math.abs(Number(iva.porcentaje) - porcentajeIva) < 0.01)
      const idAFIP = ivaAFIPEncontrado ? ivaAFIPEncontrado.ivaAFIP : 5
  
      if (!gruposIva[idAFIP]) {
        gruposIva[idAFIP] = {
          id: idAFIP,
          baseImponible: 0,
          importeIva: 0,
        }
      }
  
      const precioItem = Number(item?.precio || 0) * Number(item?.cantidad || 0)
      const descuentoItem = (precioItem * Number(item?.porcentajeDescuento || 0)) / 100
      const precioSinDescuento = precioItem - descuentoItem
      const baseImponibleItem = precioSinDescuento / (1 + porcentajeIva / 100)
      const ivaItem = precioSinDescuento - baseImponibleItem
  
      gruposIva[idAFIP].baseImponible += baseImponibleItem
      gruposIva[idAFIP].importeIva += ivaItem
    })
  
    return Object.values(gruposIva).map((grupo) => ({
      Id: grupo.id,
      BaseImp: Number.parseFloat(grupo.baseImponible.toFixed(2)),
      Importe: Number.parseFloat(grupo.importeIva.toFixed(2)),
    }))
  }
  
  export const resolverDatosDocumentoAfip = ({ tipoFacturaId, rawDoc, cuitGlobal = "" }) => {
    const documento = normalizarDocumentoFiscal(rawDoc)
    const cuitFallback = normalizarDocumentoFiscal(cuitGlobal)
  
    if (tipoFacturaId === 1) {
      if (documento.length === 11) {
        return { docTipo: 80, docNro: Number(documento), documento }
      }
  
      if (cuitFallback.length === 11) {
        return { docTipo: 80, docNro: Number(cuitFallback), documento: cuitFallback }
      }
  
      return {
        error: "CUIT invalido (11 digitos)",
        documento,
      }
    }
  
    if (tipoFacturaId === 2) {
      if (documento.length === 11) {
        return { docTipo: 80, docNro: Number(documento), documento }
      }
  
      if (documento.length === 8) {
        return { docTipo: 96, docNro: Number(documento), documento }
      }
  
      return {
        docTipo: 99,
        docNro: 0,
        documento: "",
      }
    }
  
    if (tipoFacturaId === 3) {
      return {
        docTipo: 99,
        docNro: 0,
        documento: "",
      }
    }
  
    return {
      error: "Tipo de comprobante invalido",
      documento,
    }
  }
  
  export const resolverCondicionIvaReceptor = ({ idCondicionIva, docTipo }) => {
    const idCondicion = Number(idCondicionIva)
  
    if (Number.isFinite(idCondicion) && idCondicion > 0) {
      return idCondicion
    }
  
    if (docTipo === 80) {
      return 1
    }
  
    return 5
  }
  
  export const calcularTotalesFacturaAfip = ({ tipoFacturaId, total, items, ivaAFIP }) => {
    const totalNumerico = Number(total || 0)
  
    if (tipoFacturaId === 3) {
      return {
        neto: totalNumerico,
        iva: 0,
        ivaDetallado: [],
      }
    }
  
    const ivaDetallado = calcularIvaDetalladoPorAlicuotas(items, ivaAFIP)
    const totalBaseImponible = ivaDetallado.reduce((sum, item) => sum + Number(item.BaseImp || 0), 0)
    const totalIva = ivaDetallado.reduce((sum, item) => sum + Number(item.Importe || 0), 0)
  
    return {
      neto: Number.parseFloat(totalBaseImponible.toFixed(2)),
      iva: Number.parseFloat(totalIva.toFixed(2)),
      ivaDetallado,
    }
  }
  
  export const construirItemsAfip = (items, descripcionOverride = "") =>
    (items || []).map((item, index) => ({
      codigo: item?.codigo || item?.idItem || `ITEM-${index + 1}`,
      descripcion:
        (index === 0 && descripcionOverride ? descripcionOverride : "") ||
        item?.descripcion ||
        item?.descripcionServicio ||
        "",
      cantidad: Number(item?.cantidad || 0),
      unidad: item?.unidad || "Unidad",
      precio: Number(item?.precio || 0),
      porcentajeDescuento: Number(item?.porcentajeDescuento || 0),
      impuestoData: item?.impuestoData ?? undefined,
      ivaPercentage: item?.ivaPercentage ?? item?.impuestoData?.porcentaje ?? undefined,
    }))
  